export function putWithProgress(url, file, contentType, onProgress) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("PUT", url);
        xhr.setRequestHeader("Content-Type", contentType);


        xhr.upload.onprogress = (event) => {
            if (event.lengthComputable === true) {
                const percent = Math.round((event.loaded / event.total) * 100);
                onProgress(percent);
            } else {
                onProgress(0);
            }
        };


        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve();
            } else {
                reject(new Error("Upload failed with status " + xhr.status));
            }
        };


        xhr.onerror = () => {
            reject(new Error("Network error during upload"));
        };


        xhr.send(file);
    });
}